module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/plus-102f68cc055a07e59cd5243a9ac1c03c.svg";